import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { BRAND } from "../../data/content";
import { Phone, Mail, MapPin } from "lucide-react";

const LINKS = [
  ["Inspections", "/inspections"], ["Home Inspection", "/inspections#residential-home"], ["Investor Inspection", "/inspections#investor-property"],
  ["Field Inspections", "/inspections#occupancy-verification"], ["Draw Inspections", "/inspections#construction-draw"], ["Property Preservation", "/property-preservation"], ["Service Areas", "/service-areas"],
  ["For Investors", "/packages"], ["About", "/about"], ["FAQ", "/faq"], ["Contact", "/contact"], ["Privacy Policy", "/privacy"], ["Terms", "/terms"],
];

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-[#F5F3EC]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 py-14 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-4 text-sm font-semibold text-[#0B132B]">Vertexhub Ventures LLC — Property Inspections & Investor Support in Pennsylvania</p>
          <div className="mt-5 space-y-3 text-sm text-slate-600">
            {BRAND.offices.map((o) => (
              <a key={o.name} href={o.href} target="_blank" rel="noopener noreferrer" className="flex gap-2 hover:text-gold" data-testid={`footer-office-${o.name.split(" ")[0].toLowerCase()}`}>
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" /> <span><b>{o.name}:</b> {o.address}</span>
              </a>
            ))}
            <a href={BRAND.phoneHref} className="flex items-center gap-2 hover:text-gold"><Phone className="h-4 w-4 text-gold" /> {BRAND.phone}</a>
            <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-gold"><Mail className="h-4 w-4 text-gold" /> {BRAND.email}</a>
          </div>
        </div>
        <ul className="grid grid-cols-2 gap-2 text-sm lg:col-span-1">
          {LINKS.map(([l, to]) => <li key={l}><Link to={to} className="text-slate-600 hover:text-gold">{l}</Link></li>)}
        </ul>
        <div className="text-sm text-slate-600">
          <p>Business services, LLC formation and registered agent: <a href="https://vhubagent.com" target="_blank" rel="noopener noreferrer" className="font-semibold text-gold underline">vhubagent.com</a></p>
        </div>
      </div>
      <p className="mt-10 border-t border-slate-300 pt-6 text-xs leading-relaxed text-slate-500" data-testid="footer-disclaimer">
        Vertexhub Ventures LLC provides property inspection and real estate investor support services in Pennsylvania. Home inspections are visual, non-invasive and performed under the InterNACHI Standards of Practice. We are not a law firm, title company, bank or lender, and we do not provide legal, tax or investment advice. Financing is offered by third-party lenders subject to their approval. We do not perform repairs on any property we inspected within the past 12 months.
      </p>
      <p className="mt-4 text-xs text-slate-400">© 2026 Vertexhub Ventures LLC</p>
    </div>
  </footer>
);
